/* eslint-disable no-console */
import {Divider} from 'antd';
import React, {useEffect, useState} from 'react';

import facilityImage from '../../../../../assets/facilityImage.png';
import {ReactComponent as FloorSizeIcon} from '../../../../../assets/icons/FloorSizeIcon.svg';
import {ReactComponent as NoEmployeeIcon} from '../../../../../assets/icons/NoEmployeeIcon.svg';
import {FacilityKey} from '../../../../../components/Forms/Constants/IP/FacilityKeyLabel';
import {facilityTypeIds} from '../../../../../components/Table/Constants/Common';
import PopoverMapData from '../../../../../components/Table/Popover/PopoverMapData';
import FilteredUnit from '../../../../../constants/FilteredUnit';
import useJSONStore from '../../../../../store/StaticJson/jsonStore';
import {formatIndian} from '../../../../../utils/formatIndian';

const FacilityMapData: React.FC<{
  mapRef: any[];
  data: any[];
  setEditData: React.Dispatch<any>;
  setIsEdit: React.Dispatch<React.SetStateAction<boolean>>;
  handleDelete: (_id: string[] | string) => void;
  setShowModel: React.Dispatch<React.SetStateAction<boolean>>;
  selectedFacility?: string;
  setSelectedFacility: React.Dispatch<React.SetStateAction<string | undefined>>;
}> = ({
  mapRef,
  data,
  handleDelete,
  setEditData,
  setIsEdit,
  setShowModel,
  selectedFacility,
  setSelectedFacility
}) => {
  const [showPopup, setShowPopup] = useState<boolean[]>(
    Array(data.length).fill(false)
  );

  const facilityType = useJSONStore((state) => state.facilityType);

  const handleScroll = () => {
    setShowPopup(Array(data.length).fill(false));
  };

  const singleRef: any[] = [];

  useEffect(() => {
    const index = data?.findIndex((t) => t?._id === selectedFacility);
    singleRef[index]?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });
  }, [selectedFacility]);

  return (
    <div>
      <div className="facilityListContainer" onScroll={handleScroll}>
        {data.map((items: any, index: number) => {
          return (
            <div key={index} ref={(ref) => singleRef.push(ref)}>
              <div
                className="faclityContainer"
                onClick={() => {
                  mapRef[index].fire('click');
                  setSelectedFacility(items._id);
                }}
                style={{
                  backgroundColor:
                    selectedFacility === items._id ? '#DDF7FA39' : '#FFFFFF',
                  borderLeft:
                    selectedFacility === items._id ? '2px solid #3BB3C1' : ''
                }}
              >
                <div
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    flexDirection: 'row'
                  }}
                >
                  <div className="facilityImage">
                    <img src={facilityImage} height={68} width={68} />
                  </div>
                  <div className="facilityData">
                    <div className="facilityName">
                      {items?.[FacilityKey.FACILITY_NAME]}
                    </div>
                    <div className="facilityTypeLeased">
                      {`${facilityType.find((typeItem: any) => {
                        return typeItem.value === items?.type;
                      })?.label}
                       | ${items?.isLeased ? 'Leased' : 'Non-Leased'}`}
                    </div>
                    <div className="bdProtected">
                      {`Biodiversity Protected Area : 
                      ${items?.[FacilityKey.BIO_PROTECTED] ? 'Yes' : 'No'}`}
                    </div>
                    <div className="address">{`${items?.fullAddress}`}</div>
                    <div className="employeeFloorSpace">
                      <div className="efFlex">
                        <NoEmployeeIcon />
                        <div>
                          <div className="title">
                            {`${formatIndian(
                              items?.[FacilityKey.NO_EMP]
                            )} Employees`}
                          </div>
                        </div>
                      </div>
                      <div className="efFlex">
                        <FloorSizeIcon />
                        <div>
                          <div className="title">
                            {`Floor Size: ${formatIndian(
                              items?.[FacilityKey.FLOOR_SPACE]
                            )} ${
                              items?.[FacilityKey.FLOOR_SPACE]
                                ? FilteredUnit(items.country).area
                                : ''
                            }`}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="threeDotIcon">
                  <PopoverMapData
                    setEditData={setEditData}
                    setIsEdit={setIsEdit}
                    handleDelete={handleDelete}
                    setShowModel={setShowModel}
                    showPopup={showPopup}
                    setShowPopup={setShowPopup}
                    items={items}
                    index={index}
                    blockDelete={items?.type === facilityTypeIds.headquarter}
                  />
                </div>
              </div>
              <Divider style={{margin: '0px'}} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FacilityMapData;
